<template>
    <div class="widget-wrap">
        <div :class="['widget', 'widget-loader', isExpanded ? 'expanded' : 'normal']">
            <div class="widget-body">
                <div class="widget-loader-wrapper">
                    <Loader :visible="true" css-class="widget-loader" />
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import Loader from '../../common/Loader.vue';

export default {
    name: 'LoaderWidget',

    components: { Loader },

    props: {
        isExpanded: {
            type: Boolean,
            required: true,
        },
    },
};
</script>
